import React from "react";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { allSeoLandingLinks } from "../../data/seoLandingPages.js";

const quickLinks = [
  { to: "/banquets", label: "Banquet Halls" },
  { to: "/store", label: "DecorZoom Store" },
  { to: "/subcategory/first-birthday-decorations", label: "First Birthday Decorations" },
  { to: "/subcategory/anniversary-decoration", label: "Anniversary Decoration" },
  { to: "/subcategory/welcome-baby-decoration", label: "Welcome Baby Decoration" },
];

export default function HomePreviewSeoFooter() {
  return (
    <footer className="bg-[linear-gradient(180deg,#0B2822_0%,#0A3D3A_100%)] px-4 py-14 text-white sm:px-6">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.4fr]">
          <div>
            <p className="font-display text-2xl font-bold tracking-tight text-white">DecorZoom</p>
            <p className="mt-2 text-sm leading-6 text-white/70">
              Balloon decoration, birthday setups, baby showers and banquet booking across Delhi NCR.
            </p>
            <div className="mt-4 space-y-2 text-sm text-white/80">
              <a href="tel:+918377982191" className="flex items-center gap-2 hover:text-zoom-goldSoft">
                <FaPhoneAlt aria-hidden="true" /> +91 83779 82191
              </a>
              <a
                href="https://wa.me/918377982191"
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 hover:text-zoom-goldSoft"
              >
                <FaWhatsapp aria-hidden="true" /> WhatsApp us
              </a>
              <p>Serving Delhi, Noida, Ghaziabad, Gurgaon and Faridabad.</p>
            </div>

            <div className="mt-6">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zoom-goldSoft">Explore</p>
              <ul className="mt-3 space-y-2 text-sm">
                {quickLinks.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="text-white/80 hover:text-white hover:underline">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zoom-goldSoft">Popular Decoration Searches</p>
            <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-2 text-sm text-white/75 sm:grid-cols-2 lg:grid-cols-3">
              {allSeoLandingLinks.map((item) => (
                <Link key={item.to} to={item.to} className="hover:text-white hover:underline">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-xs text-white/50">
          &copy; {new Date().getFullYear()} DecorZoom. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
